import { Alert } from 'react-bootstrap'
import React from 'react'

export const EnterpriseEnforcedInfoBox: React.FC = () => {
  return (
    <Alert variant='warning' className='d-flex gap-3 align-items-center'>
      <i className='bi bi-info-square zocks-text-primary consent-settings-info-square' />
      <span className='zocks-text-gray-900'>Managed at account or enterprise level.</span>
    </Alert>
  )
}
